export default {
  extraLarge: '@media (min-width: 1431px)',
  large: '@media (min-width: 1140px) and (max-width: 1430px)',
  medium: '@media (min-width: 768px) and (max-width: 1139px)',
  notMobile: '@media (min-width: 766px)',
};
